import { render, staticRenderFns } from "./PartsDesigner.vue?vue&type=template&id=c7d5ea12"
import script from "./PartsDesigner.vue?vue&type=script&lang=ts"
export * from "./PartsDesigner.vue?vue&type=script&lang=ts"
import style0 from "./PartsDesigner.vue?vue&type=style&index=0&id=c7d5ea12&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports